export class ConfirmationDialogResult {
  constructor(public confirmed: boolean) {}
}
